<template>
  <div :class="buildClasses">
    <!--
      @slot slot to render the key value pairs
    -->
    <slot />
  </div>
</template>

<script>
export default {
  name: 'SbKeyValueContainer',
  props: {
    type: {
      type: String,
      required: true,
    },
    emphasis: {
      type: String,
      default: 'key',
      validator: (val) => val.match(/(key|value)/),
    },
    emphasisType: {
      type: String,
      default: 'color',
      validator: (val) => val.match(/(color|bold)/),
    },
  },
  computed: {
    buildClasses() {
      const baseClass = `sb-key-value__${this.type}`;
      const classes = [baseClass];
      if (this.emphasis === this.type) classes.push(`${baseClass}--emphasize-${this.emphasisType}`);
      else classes.push(`${baseClass}--deemphasize-${this.emphasisType}`);
      return classes;
    },
  },
};
</script>

<style lang='scss'>
@import '@src/components/KeyValue/style/sb-key-value-container.scss';
</style>
